import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { SearchSchema } from '@/routes/_staff/person/$id/_profile/apps/-zod-schemas';
export const Route = createFileRoute('/_staff/person/alumni/$id/_profile/apps/')({
  validateSearch: zodValidator(SearchSchema),
  loaderDeps: ({
    search
  }) => ({
    search
  })
});